import {ID, AmutelecomResponse, Response} from '../../../../../_metronic/helpers'
import { Country } from '../../../country/countries-list/core/_models'
export type Company = {
  id?: any 
  company_name?: string
  company_logo?: string
  country_id?:string
  country?: Country |undefined
}

export type CompaniesQueryResponse = AmutelecomResponse<Company[]>

export const initialCompany: Company = {
    id: '',
    company_name: "",
    company_logo: "",
    country_id:"",
    country: {
      country_name: '',
      id: '',
      language_id: 1,
    }
}
